module.exports = __webpack_public_path__ + "img/ic_store_bottom_img.d6636419.png";